import { createSelector } from 'reselect';
import CarrierNestingLocationColumns from '../../containers/CarrierNestingLocationColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';
import { getPropertyValueByPath } from "../../../../../../react-table/helpers/utils";
import { getReportMode, getReportState } from "../../../../../common/redux/selectors/ReportsSelectors";
import CarrierNestingLocationData
  from "../../containers/CarrierNestingLocationData";

export const COLUMN_ACCESSOR_CONSIGNMENT_TOTAL = 'consignment.total';
export const COLUMN_ACCESSOR_RECEPTACLES_TOTAL = 'receptacles.total';

export const HEADER_CONSIGNMENT = 'consignment';
export const HEADER_RECEPTACLES = 'receptacles';

export const COLUMN_LEAF_EXCLUSIONS = ['postalOperator'];

export const PROPERTY_ORIGINAL_GRAND_TOTAL = 'originalGrandTotal';
export const PROPERTY_ORIGINAL_GROUP_TOTAL = 'originalGroupTotal';

export const getGeneratedOnDateTime = state => state
  .reporting.CARDIT_NESTING_LOCATION_801.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.CARDIT_NESTING_LOCATION_801.isLoading;

export const getIsFiltered = state => state.reporting.CARDIT_NESTING_LOCATION_801.filtering &&
  state.reporting.CARDIT_NESTING_LOCATION_801.filtering.appliedFilters &&
  state.reporting.CARDIT_NESTING_LOCATION_801.filtering.appliedFilters.some(filter => !filter.value.clearFilter);

export const getData =
  ReportDefinitions.CARDIT_NESTING_LOCATION_801.getDataFunction();

export const getOriginalGrandTotal = state => state.reporting.CARDIT_NESTING_LOCATION_801.data
  .map(row => getPropertyValueByPath(row, COLUMN_ACCESSOR_RECEPTACLES_TOTAL)[0])
  .reduce((grandTotal, groupTotal) => grandTotal + groupTotal, 0);

export const getColumns =
  // eslint-disable-next-line max-len
  createSelector(
    getData,
    state => state.reporting.CARDIT_NESTING_LOCATION_801.requestParams,
    state => getReportMode(state, ReportDefinitions.CARDIT_NESTING_LOCATION_801.id),
    CarrierNestingLocationColumns,
  );

export const getFilteredAndSortedData =
  createSelector(
    state => getReportState(state, ReportDefinitions.CARDIT_NESTING_LOCATION_801.id),
    getColumns,
    CarrierNestingLocationData,
  );
